/**
 * Wann der Pre-Score nach einem Sync startet (UX-Audit WP5, A1-V01). Vorher
 * startete er nach JEDEM Ende, auch nach einem gescheiterten Sync; der Befund
 * ueber den alten Bestand galt danach als frisch.
 *
 * `hadJobId` false heisst: der Hook kennt keine Job-ID (Sync ausserhalb dieses
 * Hooks gestartet). Dann bleibt das alte Verhalten, weil es nichts zu pruefen
 * gibt; ein Befund zu viel ist dort billiger als keiner.
 */
export function shouldStartPreScore(
  job: { status: string; feed_id: string | null } | null,
  feedId: string | null,
  hadJobId: boolean,
): boolean {
  if (!feedId) return false;
  if (!hadJobId) return true;
  return !!job && job.status === 'completed' && job.feed_id === feedId;
}
